function checkLocation() {
  let apiKey = 'dd3f01e84de843dbbe63d015ae4353d6';
  let locationChecked = localStorage.getItem("locationChecked") !== null;
  if(!locationChecked) {
	$.getJSON('https://api.bigdatacloud.net/data/ip-geolocation?key=' + apiKey, function(data) {
	  let country = data.country.isoAlpha2;
	  localStorage.setItem("locationChecked", true);
	  if(country == 'DE' || country == 'AT') {
		redirectPage('https://de.activefibershake.com');
	  } else if(country == 'CH') {
		redirectPage('https://activefibershake.ch');
	  } else if(country == 'RO') {
		redirectPage('https://ro.activefibershake.com');
	  } else {
		console.log('hungarian shop');
	  }
	});
  }
}

function redirectPage(url) {
 window.location.replace(url); 
}

$("document").ready(function() {
  
  if (typeof Swiper === "undefined") {
    console.log("Swiper not found.");
    return;
  }
  try{
      const swiper = new Swiper('.swiper-container', {
     
      direction: 'horizontal',
      loop: true,
    
      
      pagination: {
        el: '.swiper-pagination',
      },
    
      
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    
      
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  } catch (error) {
  	console.log(error);
  }

});